import {DEFAULT_PGDATA} from '../constants';
import {PaginationData} from './pagination-data';
import {FieldFilter} from '@twpub/core/models/field-filter';

/**
 * The ID representing all values in a URL.
 */
export const ALL_ID = '0';
/**
 * The type for session properties which contains string arrays.
 */
export type SessionArrayType = 'sourceLangs' | 'targetLangs' | 'sectionOids' | 'domainIds' | 'dictIds';
export type SessionValueType = 'searchTerm' | 'conceptId' | 'termId' | 'configId';

/**
 * Contains all selected values for the user's session.
 */
export class SessionObject {
  locale: string = 'en';

  version: number = 0;
  sourceLangs?: string[];
  targetLangs?: string[];
  searchTerm?: string;
  conceptId?: number;
  termId?: number;
  dictIds?: number[];
  sectionOids?: string[]
  domainIds?: number[]
  fieldFilters?: FieldFilter[];
  additionalField?: string;
  resultPaginator: PaginationData = DEFAULT_PGDATA;
  resultIndex?: number;
  configId?: number | null;
  isResultPage?: boolean = false;

  constructor(init?: Partial<SessionObject>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}
